/* eslint-disable */

import React, { useEffect, useState } from 'react';
import App from './App';
import ThemeProvider from './theme';
import { getAgentConverationNOLOGINFetch } from "./fetch/index/agentNew"
import { useParams } from 'react-router-dom';

function Iframe(props) {
  // 使用 useParams 获取参数
  const { innerScriptType } = props;
  const { publicUUID, businessAccountId, projectId, agentId, } = useParams();
  if (publicUUID && businessAccountId && projectId && agentId) {
    return <App publicUUID={publicUUID} businessAccountId={businessAccountId} projectId={projectId} agentId={agentId} type={"iframe"} innerScriptType={innerScriptType} />
  } else {
    return "Parameter error, please check and try again."
  }
}

export default Iframe;
